import React from "react";
import "./Header.css";

function Header() {
  return (
    <div>
      <ul>
        <li>
          <a href="/">Hjem</a>
        </li>
        <li>
          <a href="/addWine">Tilføj vin</a>
        </li>
        <li>
          <a href="/overview">Oversigt</a>
        </li>
      </ul>
    </div>
  );
}

export default Header;
